




















































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { IAttachment } from '@/types/data-objects/attachments'
import {
  IAtMentionUser,
  IDescriptionTemplate,
} from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'TaskDetailHeaderMessage',

  props: {
    description: {
      type: String,
      required: true,
    },
    initialAttachments: {
      type: Array as () => IAttachment[],
      default: (): IAttachment[] => [],
    },
    mentionUsers: {
      type: Array as () => IAtMentionUser[],
      required: true,
    },
    savedTemplates: {
      type: Array as () => IDescriptionTemplate[],
      default: (): IDescriptionTemplate[] => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      ColorAssistant,

      internalDescription: '',
      removedAttachments: [],
      listFileUploadIDs: [],
      listAtMentionIDs: [],

      clearAttachments: false,
      messageEditing: false,
      autoFocusEditor: false,
    }
  },

  computed: {
    hasAttachments(): boolean {
      return this.initialAttachments.length > 0
    },
    hasDescription(): boolean {
      if (
        this.internalDescription === '<p><br></p>' ||
        this.internalDescription === null ||
        this.internalDescription === ''
      ) {
        return false
      } else {
        return true
      }
    },

    internalAttachments: {
      get(): any {
        return this.initialAttachments
      },
      set(newValue: any) {
        this.$emit('update:initialAttachments', newValue)
      },
    },
  },

  watch: {
    description: {
      immediate: true,
      handler(newVal: string) {
        this.internalDescription = newVal
      },
    },
  },

  methods: {
    /**
     * Handle click on message div to avoid edit when clicking on links
     */
    async handleDescriptionClick(event: any) {
      if (this.isDisabled) {
        return
      }

      // Verify if there's no text selected
      const isHighlightingText =
        window
          .getSelection()
          .toString()
          .trim() !== ''

      const isClickingLink = event.target.tagName.toUpperCase() === 'A'

      if (!(isClickingLink || isHighlightingText)) {
        this.focusEditor()
      }
    },

    async focusEditor() {
      this.messageEditing = true
      this.autoFocusEditor = true
    },

    addFileHandler(files: IAttachment[]) {
      this.listFileUploadIDs = files.map(item => item.id)
    },

    /**
     * Remove file from FormData
     */
    removeFileHandler(id: number) {
      const file = this.initialAttachments.find(item => item.id === id)

      if (file && file.status !== 'ready') {
        this.removedAttachments.push(id)
      } else {
        this.listFileUploadIDs = this.listFileUploadIDs.filter(
          item => item === id,
        )
        this.internalAttachments = this.internalAttachments.filter(
          (item: any) => item.id === id,
        )
      }
    },

    insertMentions(matches: any) {
      this.listAtMentionIDs = matches
    },

    undoUpdates() {
      this.messageEditing = false
      this.internalDescription = this.description
      this.resetMetaData()
    },

    submitUpdates() {
      this.messageEditing = false
      if (
        this.description !== this.internalDescription ||
        (this.removedAttachments && this.removedAttachments.length > 0) ||
        (this.listFileUploadIDs && this.listFileUploadIDs.length > 0)
      ) {
        const remove =
          this.removedAttachments.length > 0 ? this.removedAttachments : null
        const upload =
          this.listFileUploadIDs.length > 0 ? this.listFileUploadIDs : null

        this.$emit('update-description', {
          description: this.internalDescription,
          listAtMentionIDs: this.listAtMentionIDs,
          listFileUploadIDs: upload,
          listRemovedAttachmentIDs: remove,
        })

        this.resetMetaData()
      }
    },

    resetMetaData() {
      this.listAtMentionIDs = []
      this.listFileUploadIDs = []
      this.removedAttachments = []
      this.clearAttachments = true
    },
  },
})
